'use client';

import {createFlagsmithInstance} from 'flagsmith/isomorphic';
import {FlagsmithProvider} from 'flagsmith/react';
import type {IState} from 'flagsmith/types';
import {useRef, useEffect} from 'react';
import type {ReactElement} from 'react';

export const FlagsProvider = ({children, flagsmithState}: {children: React.ReactNode; flagsmithState?: IState}) => {
  const flagsmithRef = useRef(createFlagsmithInstance());

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const hostname = window.location.hostname;
      flagsmithRef.current.setTrait(`domain`, hostname);
    }
  }, []);

  return (
    <FlagsmithProvider flagsmith={flagsmithRef.current} serverState={flagsmithState}>
      {children as ReactElement<any>}
    </FlagsmithProvider>
  );
};
